import React, { useState } from "react";
import SearchButtons from "components/SearchButtons";
import doubleArrow from "../../../../assets/icon/double-arrow-down-purple.svg";
import ReactStrapTable from "components/reactStrapTable";
import { FormGroup, Input } from "reactstrap";

const Preferences = () => {
  const [data, setData] = useState([]);
  const [showDetails, setShowDetails] = useState("configurations");

  const toggle = (id) => {
    setShowDetails((prevId) => (prevId === id ? null : id));
  };

  const RefillSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const PickUpSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const PharmacyLocationSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const PackagingPrefrencesSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const DosageSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const AccessibilitySwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const ConfigurationSwitch = () => {
    return (
      <div>
        <FormGroup style={{ fontSize: "large" }} switch>
          <Input type="switch" />
        </FormGroup>
      </div>
    );
  };

  const RefillColumnData = [
    {
      dataField: "option",
      text: "Option",
      show: true,
      sort: true,
      cellRenderer: (rowData) => RefillSwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const RefillRowData = [
    {
      configurations: "Manual Refill",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Auto Refill",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Med Sync",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const PickUpColumnData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => PickUpSwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const PickUpRowData = [
    {
      configurations: "In-Store",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Delivery",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Curbside",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Mail Order",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const accessibilityColumnData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => AccessibilitySwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const accessibilityRowData = [
    {
      configurations: "WheelChair",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Sign Language",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Large Print Labels",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Monographs",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const ConfigurationColumnData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => ConfigurationSwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const ConfigurationRowData = [
    {
      configurations: "Phone Call",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "SMS",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Email",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "In-App Notification",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const PharmacyLocationColData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => PharmacyLocationSwitch(rowData),
    },
    {
      dataField: "locations",
      text: "Locations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const PharmacyLocationRowData = [
    {
      locations: "USA",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      locations: "XXXX",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      locations: "XXXX",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const PackagingPreferencesColData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => PackagingPrefrencesSwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const PackagingPreferencesRowData = [
    {
      configurations: "Blistor Pack",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Unit Dose",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Easy-Open Cap",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  const DosageColData = [
    {
      dataField: "option",
      text: "Option",
      sort: true,
      show: true,
      cellRenderer: (rowData) => DosageSwitch(rowData),
    },
    {
      dataField: "configurations",
      text: "Configurations",
      show: true,
      sort: true,
    },
    {
      dataField: "modifieddate",
      text: "Modified Date",
      sort: true,
      show: true,
    },
    {
      dataField: "modifiedby",
      text: "Modified By",
      sort: true,
      show: true,
    },
  ];

  const DosageRowData = [
    {
      configurations: "Prefers Oral Liquids",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Small Oral Solids Ok",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Split Partial Tablets",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
    {
      configurations: "Add Flavoring to Liquids",
      modifieddate: "03-23-2024",
      modifiedby: "Hiliary Cheatwood",
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: "10px" }}>
        <SearchButtons
          InSize={250}
          placeHolder={"Search by Preferences"}
          data={data}
          setFilterData={() => undefined}
        />
      </div>
      <div className="medical-condition">
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="heading-text"
            style={{
              width: "100vw",
              height: "auto",
              justifyContent: "space-between",
            }}
          >
            <div>Communication Configurations </div>
            <div>
              <span onClick={() => toggle("configurations")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "configurations" ? "rotate(180deg)" : "",
                    transition: "  0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {showDetails == "configurations" ? (
          <div className="configuration-header">
            <div className="prescription-body">
              <div className="d-flex justify-content-start align-items-center">
                <div className="presceription-refill">
                  Notification Preference
                </div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={ConfigurationRowData}
                  columns={ConfigurationColumnData}
                  hasPagination={false}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="medical-condition">
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="heading-text"
            style={{
              width: "100vw",
              height: "auto",
              justifyContent: "space-between",
            }}
          >
            <div>Prescription Fulfilment </div>
            <div>
              <span onClick={() => toggle("prescription")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "prescription" ? "rotate(180deg)" : "",
                    transition: "  0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {showDetails == "prescription" ? (
          <div className="prescription-header">
            <div className="prescription-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="presceription-refill">Refill</div>
                <div className="choose-one">Choose one</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={RefillRowData}
                  columns={RefillColumnData}
                  hasPagination={false}
                />
              </div>
            </div>
            <div className="prescription-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="presceription-refill">Pick-Up</div>
                <div className="choose-one">Choose one</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={PickUpRowData}
                  columns={PickUpColumnData}
                  hasPagination={false}
                />
              </div>
            </div>
            <div className="prescription-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="presceription-refill">
                  Preferred Pharmacy Location
                </div>
                <div className="choose-one">Choose one</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={PharmacyLocationRowData}
                  columns={PharmacyLocationColData}
                  hasPagination={false}
                />
              </div>
            </div>
            <div className="prescription-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="presceription-refill">
                  Packaging Preferences
                </div>
                <div className="choose-one">Choose one</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={PackagingPreferencesRowData}
                  columns={PackagingPreferencesColData}
                  hasPagination={false}
                />
              </div>
            </div>
            <div className="prescription-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="presceription-refill">
                  Dosage From Prederences
                </div>
                <div className="choose-one">Choose one</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={DosageRowData}
                  columns={DosageColData}
                  hasPagination={false}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="medical-condition">
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="heading-text"
            style={{
              width: "100vw",
              height: "auto",
              justifyContent: "space-between",
            }}
          >
            <div>Accessibility and Services </div>
            <div>
              <span onClick={() => toggle("accessibility")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "accessibility" ? "rotate(180deg)" : "",
                    transition: "  0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {showDetails == "accessibility" ? (
          <div className="accessibility-header">
            <div className="prescription-body">
              <div className="d-flex justify-content-start align-items-center">
                <div className="presceription-refill">Assistive Needs</div>
              </div>
              <div className="table-card scroll-table position-relative rounded border-0">
                <ReactStrapTable
                  data={accessibilityRowData}
                  columns={accessibilityColumnData}
                  hasPagination={false}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Preferences;
